import { useState } from 'react';

import { IdentityView } from './identity';
import { ResetView } from './reset';
import { TimeoutView } from './timeout';
import { VerifyView } from './verify';
import { CustomerColors } from '../../components/customer-colors';

export function ResetPage() {
    const [view, setView] = useState(determinInitialView());

    function determinInitialView() {
        const id = sessionStorage.getItem("id");
        if (!id)
            return "identity";

        const tempPass = sessionStorage.getItem("temporary_password");
        if (!tempPass)
            return "verify";

        return "reset";
    }

    function renderView() {
        switch (view) {
            case "reset":
                return <ResetView changeView={setView} />;
            case "verify":
                return <VerifyView changeView={setView} />;
            case "timeout":
                return <TimeoutView changeView={setView} />;
            default:
                return <IdentityView changeView={setView} />;
        }
    }

    return (<>
        {renderView()}
        <CustomerColors />
    </>);
}